export default "__VITE_ASSET__DwHZfopQ__"